(function () {
    'use strict';

    angular
        .module('app')
        .factory('TagsService', TagsService);

    TagsService.$inject = [
        '$http',
        'DataService',
        'UrlService'];

    function TagsService(
        $http,
        DataService,
        UrlService) {
        var resourceUrl = 'tag';
        var service = {};

        angular.extend(service, DataService(resourceUrl));

        angular.extend(service, {
            getUsageAreas: getUsageAreas,
            getLinkedItems: getLinkedItems,
            multiDelete: multiDelete
        });

        return service;

        /*
         * Retrieves a list of where tags can be used.
         */
        function getUsageAreas() {
            var requestUrl = UrlService.getWebAPIUrl() + '/TagUsageArea';

            return $http.get(requestUrl).then(function ok(response) {
                return response.data;
            });
        }

        /*
         * Retrieves a list of items linked to the tags. Refer to TagLinkedItemViewModel.cs.
         *
         * @param {int} tagIds - Ids of the tags for which the items are to be retreived
         * @param {array} excludeUsageAreas - Array containing string representations of usage areas which are to be excluded from the list of linked items
         *
         * @returns {array} A list of items linked to the tags
         */
        function getLinkedItems(tagIds, excludeUsageAreas) {
            var requestUrl = UrlService.getWebAPIUrl() + '/tag/linkeditems';
            var queryString = '';

            if (!_.isNil(excludeUsageAreas) && excludeUsageAreas !== '') {
                if (angular.isArray(excludeUsageAreas)) {
                    angular.forEach(excludeUsageAreas, function (usageArea) {
                        queryString += queryString.length > 0 ? '&': '?';
                        queryString += 'excludeusageareas=' + usageArea;
                    });
                } else {
                    queryString += '?excludeusageareas=' + excludeUsageAreas;
                }
            }

            if (!_.isNil(tagIds) && _.isArray(tagIds)) {
                angular.forEach(tagIds, function (id) {
                    queryString += queryString.length > 0 ? '&' : '?';
                    queryString += 'ids=' + id;
                });
            }

            return $http.get(requestUrl + queryString).then(
                function ok(response) { return response.data; }, null);
        }

        /**
         * Deletes multiple tags with a single request
         *
         * @param {array} tagIds - An array of tag ids for the tags to be deleted.
         * @returns {promise} A promise resolved once the tag deletion is complete, rejects with a http response if there was a server-side error.
         */
        function multiDelete(tagIds) {
            return $http.post(UrlService.getWebAPIUrl() + '/tagdelete', tagIds);
        }
    }
})();